import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { Instances } from './pages/Instances';
import { Clusters } from './pages/Clusters';
import MASInstances from './pages/MASInstances';
import { Monitoring } from './pages/Monitoring';
import { AlertsAndAlarms } from './pages/AlertsAndAlarms';
import { ServiceHealth } from './pages/ServiceHealth';
import { Workflows } from './pages/Workflows';
import { DevInstances } from './pages/DevInstances';
import { PRInstances } from './pages/PRInstances';
import { DevImages } from './pages/DevImages';
import OpenshiftClusters from './pages/OpenshiftClusters';
import { ClusterBrokers } from './pages/ClusterBrokers';
import { Approvals } from './pages/Approvals';
import { Tenants } from './pages/Tenants';
import { Notifications } from './pages/Notifications';
import { Convos } from './pages/Convos';
import { MyDocuments } from './pages/MyDocuments';
import { Login } from './pages/Login';
import { AuthProvider } from './contexts/AuthContext';
import { Groups } from './pages/admin/Groups';
import { Users as AdminUsers } from './pages/admin/Users';
import { CacheManagement } from './pages/admin/CacheManagement';
import { ApprovalsConfig } from './pages/admin/ApprovalsConfig';
import { IdentityProviders } from './pages/admin/IdentityProviders';
import { AiConfig } from './pages/admin/AiConfig';
import { AiWorkspaces } from './pages/admin/AiWorkspaces';
import { Integrations } from './pages/admin/Integrations';
import { Plugins } from './pages/admin/Plugins';
import { AiWorkflows } from './pages/AiWorkflows';
import { AiLearning } from './pages/AiLearning';
import { ServiceReports } from './pages/ServiceReports';
import { CICD } from './pages/CICD';
import { WorkspaceProvider } from './contexts/WorkspaceContext';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<Login />} />
        <Route path="/" element={<Layout><Dashboard /></Layout>} />
        <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
      
      {/* Cloud Group */}
      <Route path="/instances" element={<Layout><Instances /></Layout>} />
      <Route path="/clusters" element={<Layout><Clusters /></Layout>} />
      <Route path="/openshift-clusters" element={<Layout><OpenshiftClusters /></Layout>} />
      <Route path="/cluster-brokers" element={<Layout><ClusterBrokers /></Layout>} />
      <Route path="/kubernetes-clusters" element={<Layout><OpenshiftClusters kind="kubernetes" /></Layout>} />
      <Route path="/mas-instances" element={<Layout><MASInstances /></Layout>} />
      <Route path="/service-health" element={<Layout><ServiceHealth /></Layout>} />
      <Route path="/monitoring" element={<Layout><Monitoring /></Layout>} />
      <Route path="/alerts" element={<Layout><AlertsAndAlarms /></Layout>} />
      <Route path="/service-reports" element={<Layout><ServiceReports /></Layout>} />
      
      {/* DevOps Group */}
      <Route path="/workflows" element={<Layout><Workflows /></Layout>} />
      <Route path="/cicd" element={<Layout><CICD /></Layout>} />
      <Route path="/dev-instances" element={<Layout><DevInstances /></Layout>} />
      <Route path="/pr-instances" element={<Layout><PRInstances /></Layout>} />
      <Route path="/dev-images" element={<Layout><DevImages /></Layout>} />
      <Route path="/approvals" element={<Layout><Approvals /></Layout>} />
      
      {/* Security Group */}
      <Route path="/tenants" element={<Layout><Tenants /></Layout>} />
      <Route path="/user-groups" element={<Layout><Groups /></Layout>} />
      <Route path="/users" element={<Layout><AdminUsers /></Layout>} />
      
      {/* AI Group */}
      <Route path="/ai-workflows" element={<Layout><AiWorkflows /></Layout>} />
      <Route path="/ai-learning" element={<Layout><AiLearning /></Layout>} />

      {/* Other */}
      <Route path="/notifications" element={<Layout><Notifications /></Layout>} />
      <Route path="/convos" element={<Layout><Convos /></Layout>} />
      <Route path="/my-documents" element={<Layout><MyDocuments /></Layout>} />
      
      {/* Admin Routes */}
      <Route path="/admin/cache" element={<Layout><CacheManagement /></Layout>} />
      <Route path="/admin/approvals" element={<Layout><ApprovalsConfig /></Layout>} />
      <Route path="/admin/identity-providers" element={<Layout><IdentityProviders /></Layout>} />
      <Route path="/admin/ai-config" element={<Layout><AiWorkspaces /></Layout>} />
      <Route path="/admin/ai-config/:workspaceId" element={<Layout><WorkspaceProvider><AiConfig /></WorkspaceProvider></Layout>} />
      <Route path="/admin/integrations" element={<Layout><Integrations /></Layout>} />
      <Route path="/admin/plugins" element={<Layout><Plugins /></Layout>} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
